import css from './favoriteEquipmentWidget.module.css'
import FavouriteEquipmentLinkItem from './components/FavouriteEquipmentLinkItem'
import { useNavigate } from 'react-router-dom'
import urls from '@/navigation/urls'
import useFavoriteEquipment from './useFavoriteEquipment'
import EmptyPlaceholder from '@/shared/Common/EmptyPlaceholder'
import SkeletonFavouriteEquipmentLinkList from './components/SkeletonFavouriteEquipmentLinkItem'

interface IProps {
  loading?: boolean
}

const FavoriteEquipmentWidget = (props: IProps) => {
  const navigate = useNavigate()
  const equipmentList = useFavoriteEquipment()

  const renderFavouriteEquipmentList = () => {
    if (!equipmentList.length)
      return (
        <div className="flex-lines center height100">
          <EmptyPlaceholder inscription="Список избранного пуст" />
        </div>
      )

    if (props.loading) return <SkeletonFavouriteEquipmentLinkList />

    return equipmentList.map((equipment) => (
      <FavouriteEquipmentLinkItem
        key={equipment.id}
        equipment={equipment}
        onClick={() => navigate(urls.liftScreen(equipment.id))}
      />
    ))
  }

  return (
    <div className={css.wrapper}>
      <h2 style={{ padding: '6px 20px' }} className="text-heading-4">
        Избранное
      </h2>
      <div className={css.equipmentListWrapper}>{renderFavouriteEquipmentList()}</div>
    </div>
  )
}

export default FavoriteEquipmentWidget
